import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=4a8744b2&scoped=true"
import script from "./taskitem.js?vue&type=script&lang=js&external"
export * from "./taskitem.js?vue&type=script&lang=js&external"
import style0 from "./taskitem.scss?vue&type=style&index=0&id=4a8744b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8744b2",
  null
  
)

export default component.exports